import { Children } from "react";
import {
  TableRow,
  TableHead,
  TableCell,
  Typography,
} from "@mui/material";
import { memo } from "utils/memo";

const TableHeader = ({
  columns = [],
}: {
  columns: any[];
}) => {
  return (
    <TableHead>
      <TableRow>
        {Children.toArray(
          columns.map((column: any) => {
            return (
              <TableCell
                key={column.label}
                align={column.align || "left"}
                sx={{
                  border: "none",
                  textTransform: "capitalize",
                  padding: 1,
                }}
              >
                <Typography
                  variant="body1"
                  fontSize={14}
                  noWrap
                  fontWeight={600}
                >
                  {column.label}
                </Typography>
              </TableCell>
            );
          })
        )}
      </TableRow>
    </TableHead>
  );
};

export default memo(TableHeader);
